/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Category_TitleInputs */

const vi_expense_category_title = /** @type {(inputs: Expense_Category_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh mục khoản chi`)
};

/**

* @param {Expense_Category_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_category_title = /** @type {((inputs?: Expense_Category_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Category_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_category_title(inputs)
});